import React from 'react';
import _ from 'lodash';
import {Grid, Divider} from 'semantic-ui-react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {ISOToDisplayDate} from 'common/utils';

export const RecipientTaskHeader = (props) => {
  const {fedShare, periodOfPerformance} = props;
  const popConfig = {showDate: true};
  const startDate = ISOToDisplayDate(_.get(periodOfPerformance, 'startDate'), popConfig);
  const endDate = ISOToDisplayDate(_.get(periodOfPerformance, 'endDate'), popConfig);

  return (
    <React.Fragment>
      <Grid columns={2}>
        <Grid.Column>
          {periodOfPerformance && (
            <p>
              Period of performance: <strong>{startDate}</strong> to{' '}
              <strong>{endDate}</strong>
            </p>
          )}
        </Grid.Column>
        <Grid.Column textAlign={'right'}>
          Federal resources awarded: <strong>{fedShare}</strong>
        </Grid.Column>
      </Grid>
      <Divider />
    </React.Fragment>
  );
};

export default connectDynamic(RecipientTaskHeader);
